import * as Q from "q";
import * as globalConfig from "globalConfig";

// Models
import { EthnicOrigin } from "Content/ts/Models/Joining/EthnicOrigin";

export module EthnicOriginService {
    export function RetrieveEthnicOrigins(): Q.Promise<EthnicOrigin[]> {
        return Q($.ajax({
            url: globalConfig.Urls.EthnicOrigin.GetAllAsync,
            type: "GET",
            cache: false
        }));
    }
}